import moment, { Moment } from "moment";
import { useState, useRef, useEffect } from "react";
import useInterval from './useInterval'

const getSecondsFromExpiry = (expire: Moment) => {
  const secondsDifference = expire.diff(moment(), 's')
  return secondsDifference > 0 ? secondsDifference : 0
}

export function useSimpleCountdown(expiry: Moment, onExpire: () => void) {
  const [seconds, setSeconds] = useState(getSecondsFromExpiry(expiry));
  const [delay, setDelay] = useState<number | null>(1000)
  useInterval(() => seconds > 0 ? setSeconds(seconds - 1) : 0, delay)


  useEffect(() => {
    if (seconds <= 0) {
      setDelay(null)
      onExpire()
    }
  }, [seconds])

  useEffect(() => {
    if (!delay) setDelay(1000)
    setSeconds(getSecondsFromExpiry(expiry));
  }, [expiry])


  return seconds
}